// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.57.0',
  commit: '2d1e8b9f878dc3c27f3027ea1ca8df424ca47d44',
  branch: 'feature/APA-3874-keycloack',
  dateGenerated: '2025-12-05T13:56:39.120Z',
};